bam-product-packages-teaser {
  display: block;

  bal-card-content {
    margin-bottom: 0 !important;
  }

  .bam-icon-list-teaser__item:not(:last-child) {
    margin-bottom: 40px;
  }

  .bam-product-packages-teaser__list-points {
    padding-top: 24px;

    @include tablet() {
      padding-top: 32px;
    }

    @include desktop() {
      padding-top: 8px;
    }
  }
}
